import React, { memo, useState } from "react";
import { BsArrowRight } from "react-icons/bs";
import { NavLink, useNavigate } from "react-router-dom";

function GridWrapper({
  data,
  gridCols = "lg:grid-cols-3",
  hover = "hover:bg-subMain  hover:text-black",
  isRightArrow = true,
  imgSize="w-12 h-12",
  mainSize="text-2xl",
  cardBg="shadow bg-white"
}) {
  const navigate = useNavigate();
  const [isHoverProgress, setIsHoverProgress] = useState({
    id: -1,
    hovered: false,
  });

  const handleMouseEnter = (id) => {
    setIsHoverProgress({ id: id, hovered: true });
  };

  const textColor = (index) => {
    return (
      isHoverProgress.id === index && isHoverProgress.hovered && "text-main"
    );
  };

  return (
    <div className={`grid  grid-cols gap-6 lg:mx-10 mx-6 ${gridCols}`}>
      {data?.map((item, index) => {
        return (
          <section key={item.name} id={item.name}>
            <NavLink
              onClick={(e) => {
                e.preventDefault();
                !!item.path && navigate(item.path);
              }}
              to={item.path ? item.path : ""}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={() =>
                setIsHoverProgress({ id: -1, hovered: false })
              }
              key={index}
              className={`relative group gap-6 ${
                isRightArrow ? "h-auto" : "h-80"
              }   hover:shadow-md ${cardBg} p-5  transitions  rounded overflow-hidden cursor-pointer flex items-center flex-col`}
            >
              <div>
                <div className="flex items-center flex-col gap-2">
                  <div data-aos="zoom-in">
                    {item.isIcon === undefined || item.isIcon ? (
                      <item.Icon className={`w-12 h-12 ${textColor(index)}`} />
                    ) : (
                      <img
                        alt={item.name}
                        src={item?.Icon}
                        className={`${imgSize} object-contain  hover:bg-blend-darken`}
                      />
                    )}
                  </div>
                  <h1
                    className={`${mainSize} text-bold text-center ${textColor(
                      index
                    )}`}
                  >
                    {item.name}
                  </h1>
                </div>
                <div className="text-center lg:text-[17px] text-base  font-light h-48 mt-6">
                  <div className=" line-clamp-5">{item.description}</div>
                </div>
              </div>
              {isRightArrow && (
                <div className="absolute lg:bottom-4 bottom-4">
                  <BsArrowRight className={`${mainSize} ${textColor(index)}`} />
                </div>
              )}

              <span
                className={`absolute -bottom-1 left-0 w-0 h-2 bg-main transition-all duration-300 hover:ease-in group-hover:w-full`}
              ></span>
            </NavLink>
          </section>
        );
      })}
    </div>
  );
}

export default memo(GridWrapper);
